export default __webpack_public_path__ + "7b4007c6af3f68ea1068c7b1e12df23f.svg";